import { render } from "./NumberDetailPage.vue?vue&type=template&id=74ce444c&ts=true"
import script from "./NumberDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumberDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/number/NumberDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74ce444c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74ce444c', __exports__)) {
    api.reload('74ce444c', __exports__)
  }
  
  module.hot.accept("./NumberDetailPage.vue?vue&type=template&id=74ce444c&ts=true", () => {
    api.rerender('74ce444c', render)
  })

}


export default __exports__